<template>
  <div>
    <b-table :items="parkedSales" :fields="fields" striped responsive="sm">
      <template v-slot:cell(show_details)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
        </b-button>

        <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
          Details via check
        </b-form-checkbox>
      </template>

      <template v-slot:cell(select_sale)="row">
        <b-button size="sm" @click="selectedSale(row.item)" class="mr-2">
          Select Sale
        </b-button>
      </template>
      <template v-slot:row-details="row">
         <b-table striped hover :fields="detailsFields" :items="row.item.saleData"></b-table>
         <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>

      </template>
    </b-table>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'ParkedSalesTable',
    props: {
      parkedSales: {
        type: Array
      }
    },
    data: function(){
      return {
        fields: [ {key:'saleDateTime', label: 'Parked Time', formatter: value => {return new Date(value);}},
                  {key:'show_details', label:'Show Details'},
                  {key:'select_sale', label:'Select Sale'},
                ],
        detailsFields: [  {key:'name', label: 'Item'},{key:'qty', label:'Units'}, {key:'total', label:'Total'}]
      }
    },
    methods: {
      selectedSale(item){
        const selectedSale = {
          "key": item.saleDateTime,
          "saleData" : item.saleData
        }
        this.$emit('success', selectedSale);
      }
    },
  }
</script>
